// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1HssS","inner":"Footer_inner__3TDjM"};